import Backbone from "backbone";
import Marionette from "backbone.marionette";
import Xola from "../Xola";
import { Config } from "./Config";
import { Cookie } from "./Cookie";
import { Debug } from "./Debug";
import { DashboardView } from "../view/pages/Dashboard";
import { SettingsView } from "../view/pages/settings/SettingsView";
import { SellerIdView } from "../view/pages/SellerIdView";
import { SellersView } from "../view/pages/SellersView";
import { LoginView } from "../view/pages/LoginView";
import { DisplayCollection } from "../collections/DisplayCollection";
import { DemographicCollection } from "../collections/DemographicCollection";
import { ExperienceCollection } from "../collections/ExperienceCollection";
import { Display } from "../model/Display";
import { DisplayConfigurationView } from "../view/pages/settings/DisplayConfigurationView";
import { DisplaysView } from "../view/pages/DisplaysView";

export const Router = Marionette.AppRouter.extend({
    viewport: null,

    routes: {
        "": "dashboardAction",
        "index": "dashboardAction", // Do not use this path, it's only there for the VOID at Glendale who have an old url.
        "dashboard": "dashboardAction",
        "login": "loginAction",
        "selectSeller": "selectSellerAction",
        "selectDisplay": "selectDisplayAction",
        "settings": "settingsAction",
        "display/create": "createDisplayAction",
        "display/:displayId/configure": "configureDisplayAction"
    },

    initialize(options) {
        this.viewport = options.viewport;
    },

    execute(callback, args, name) {
        Debug.log("AppRouter.execute():", "Route matched in AppRouter:", name);

        if (callback) callback.apply(this, args);
    },

    dashboardAction() {
        if (!Config.user) {
            Debug.log("AppRouter.dashboardAction():", "User not set. Redirecting to login...");
            Backbone.history.navigate("login", {trigger: true});
            return;
        }
        if (!Config.seller) {
            Debug.log("AppRouter.dashboardAction():", "Seller not set. Redirecting to seller selection...");
            Backbone.history.navigate("selectSeller", {trigger: true});
            return;
        }
        if (!Config.display) {
            Debug.log("AppRouter.dashboardAction():", "Display not set. Redirecting to display selection...");
            Backbone.history.navigate("selectDisplay", {trigger: true});
            return;
        }

        var seller = Config.seller;
        var allExperiences = new ExperienceCollection();
        allExperiences.filters.seller = seller.id;

        //if (!Config.display.get("config").events.listings.all) {
        //    allExperiences.filters.experience = Config.display.get("config").events.listings.selected.join(",");
        //}

        var allDemographics = new DemographicCollection();
        allDemographics.filters.seller = seller.id;

        var preloadData = [];
        preloadData.push(allExperiences.fetchRecursive(10));
        preloadData.push(allDemographics.fetchRecursive(10));

        Backbone.$.when.apply(Backbone.$, preloadData).then(() => {
            Debug.log("AppRouter.dashboardAction():", "Data preload complete. Showing dashboard...");

            // Save experience collection in Xola CollectionPool - EventsCollection will search for experiences here.
            var experienceCollection = Xola.CollectionPool.getCollection(Xola.Collection.Experiences);
            experienceCollection.set(allExperiences.models);

            var demographicsCollection = Xola.CollectionPool.getCollection(Xola.Collection.Demographics);
            demographicsCollection.set(allDemographics.models);

            //noinspection JSUnresolvedVariable
            Config.timezone = seller.get("timezoneName");

            var dashboardView = new DashboardView({model: seller, settings: Config.display.get("config")});

            this.viewport.showView(dashboardView);
        });
    },

    settingsAction() {
        if (!Config.user) {
            Debug.log("AppRouter.settingsAction():", "User not set. Redirecting to login...");
            Backbone.history.navigate("login", {trigger: true});
            return;
        }
        if (!Config.seller) {
            Debug.log("AppRouter.settingsAction():", "Seller not set. Redirecting to seller selection...");
            Backbone.history.navigate("selectSeller", {trigger: true});
            return;
        }

        var settingsView = new SettingsView({model: Config.seller});

        return this.viewport.showView(settingsView);
    },

    loginAction() {
        var loginView = new LoginView();

        loginView.on("login.success", (user) => {
            Config.user = user;

            Debug.log("AppRouter.loginAction():", "Login successful. Redirecting to seller selection...");
            this.navigate("selectSeller", {trigger: true});
        });

        this.viewport.showView(loginView);
    },

    selectSellerAction() {
        if (!Config.user) {
            Debug.log("AppRouter.selectSellerAction():", "User not set. Redirecting to login...");
            this.navigate("login", {trigger: true});
            return;
        }

        var selectSellerView = null;
        var preloadData = [];
        var delegatorCollection = [];

        if (Config.user.isAdmin()) {
            Debug.log("AppRouter.selectSellerAction():", "User is an admin. Need to enter seller id.");
            selectSellerView = new SellerIdView();
        }
        else {
            if (Config.user.isSeller()) {
                Debug.log("AppRouter.selectSellerAction():", "User is a seller. Fetching seller object...");
                Config.seller = new Xola.Model.Seller({id: Config.user.id});
                Config.seller.fetch({
                    complete: () => {
                        Debug.log("AppRouter.selectSellerAction():", "Redirecting to displaySelection...");
                        this.navigate("selectDisplay", {trigger: true});
                    }
                });
                return;
            }
            else {
                Debug.log("AppRouter.selectSellerAction():", "User is a delegate. Fetching delegator collection...");
                delegatorCollection = Xola.getUser().getDelegators();
                selectSellerView = new SellersView({
                    collection: delegatorCollection
                });
                preloadData.push(delegatorCollection.fetch());
            }
        }

        Backbone.$.when.apply(Backbone.$, preloadData).then(() => {
            if (delegatorCollection.length == 1) {
                Debug.log("AppRouter.selectSellerAction():", "Only one delegator found. Fetching seller object...");
                Config.seller = new Xola.Model.Seller({id: delegatorCollection.models[0].id});

                var preloadData = [];

                preloadData.push(Config.seller.fetch());
                preloadData.push(Config.seller.getGuides().fetchRecursive(10));

                Backbone.$.when.apply(Backbone.$, preloadData).then(() => {
                    Debug.log("AppRouter.selectSellerAction():", "Redirecting to displaySelection...");
                    this.navigate("selectDisplay", {trigger: true});
                });
                return;
            }

            selectSellerView.on("seller.select", (seller) => {
                Debug.log("AppRouter.selectSellerAction():", "Seller selected. Fetching seller object...");

                Config.seller = seller;

                var preloadData = [];

                preloadData.push(Config.seller.fetch());
                preloadData.push(Config.seller.getGuides().fetchRecursive(10));

                Backbone.$.when.apply(Backbone.$, preloadData).then(() => {
                    Debug.log("AppRouter.selectSellerAction():", "Redirecting to displaySelection...");
                    this.navigate("selectDisplay", {trigger: true});
                });
            });

            selectSellerView.on("seller.cancel", () => {
                Debug.log("AppRouter.selectSellerAction():", "Seller selection canceled. Redirecting to login...");
                Xola.logout();
                Config.seller = null;
                Cookie.setApiKey(null);
                Cookie.setSellerId(null);

                this.navigate("login", {trigger: true});
            });

            this.viewport.showView(selectSellerView);
        });
    },

    selectDisplayAction() {
        if (!Config.user) {
            Debug.log("AppRouter.selectDisplayAction():", "User not set. Redirecting to login...");
            this.navigate("login", {trigger: true});
            return;
        }
        if (!Config.seller) {
            Debug.log("AppRouter.selectDisplayAction():", "Seller not set. Redirecting to seller selection...");
            this.navigate("selectSeller", {trigger: true});
            return;
        }

        var preloadData = [];
        var displayCollection = new DisplayCollection();
        preloadData.push(displayCollection.fetch({data: {seller: Config.seller.id}}));

        Backbone.$.when.apply(Backbone.$, preloadData).then(() => {
            switch (displayCollection.length) {
                case 0:
                    Debug.log("AppRouter.selectDisplayAction():", "No displays configured. Creating a default display...");
                    var display = new Display({
                        oldId: Math.random() * 1000, // Without this the API can't create the display, and oldId has to be unique
                        seller: Config.seller.id,
                        name: "Upcoming Events"
                    });
                    display.save(null, {
                        complete: () => {
                            Debug.log("AppRouter.selectDisplayAction():", "Default display created. Redirecting to dashboard...");
                            Config.display = display;
                            this.navigate("display/" + display.id + "/configure", {trigger: true});
                        }
                    });
                    break;

                default:
                    var selectDisplayView = new DisplaysView({collection: displayCollection});

                    selectDisplayView.on("display.select", (display) => {
                        Debug.log("AppRouter.selectDisplayAction():", "Display selected. Redirecting to dashboard...");
                        Config.display = display;
                        this.navigate("dashboard", {trigger: true});
                    });

                    selectDisplayView.on("display.cancel", () => {
                        Debug.log("AppRouter.selectDisplayAction():", "Display selection canceled. Redirecting to login...");
                        Xola.logout();
                        Config.seller = null;
                        Cookie.setApiKey(null);
                        Cookie.setSellerId(null);

                        this.navigate("login", {trigger: true});
                    });

                    this.viewport.showView(selectDisplayView);
            }
        });
    },

    createDisplayAction() {
        if (!Config.user) {
            Debug.log("AppRouter.createDisplayAction():", "User not set. Redirecting to login...");
            this.navigate("login", {trigger: true});
            return;
        }
        if (!Config.seller) {
            Debug.log("AppRouter.createDisplayAction():", "Seller not set. Redirecting to seller selection...");
            this.navigate("selectSeller", {trigger: true});
            return;
        }

        var display = new Display({
            seller: Config.seller.id,
            oldId: Math.random() * 1000, // Without this the API can't create the display, and oldId has to be unique
            name: null
        });
        display.save(null, {
            complete: () => {
                if (!display.id) {
                    console.error("Invalid display created. See POST /devices", display);
                }
                Debug.log("AppRouter.createDisplayAction():", "Display created successfully. Redirecting to configuration...");
                this.navigate("display/" + display.id + "/configure", {trigger: true});
            }
        });
    },

    configureDisplayAction(displayId) {
        if (!Config.user) {
            Debug.log("AppRouter.configureDisplayAction():", "User not set. Redirecting to login...");
            this.navigate("login", {trigger: true});
            return;
        }
        if (!Config.seller) {
            Debug.log("AppRouter.configureDisplayAction():", "Seller not set. Redirecting to seller selection...");
            this.navigate("selectSeller", {trigger: true});
            return;
        }

        Debug.log("AppRouter.configureDisplayAction():", "Fetching display configuration...");
        var display = new Display({id: displayId});
        display.fetch({
            complete: () => {
                var displayConfigurationView = new DisplayConfigurationView({model: display});

                this.viewport.showView(displayConfigurationView);
            }
        });
    }
});



// WEBPACK FOOTER //
// ./src/js/application/Router.js